"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var _Flex = _interopRequireDefault(require("./Flex"));

var _core = require("@emotion/core");

var Col = _react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$container = _ref.container,
      Container = _ref$container === void 0 ? _Flex.default : _ref$container,
      outerProps = (0, _objectWithoutProperties2.default)(_ref, ["children", "container"]);
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilReactCol'
  });
  return (0, _core.jsx)(Container, (0, _extends2.default)({
    flexDirection: "column",
    ref: ref
  }, dataTestProps, outerProps), children);
}); // Force TS to accept .withComponent


var ColStyled = Col;

ColStyled.withComponent = function (tag) {
  var Container = _Flex.default.withComponent(tag, {
    target: "ebn2p5z0"
  });

  return _react.default.forwardRef(function (props, ref) {
    return (0, _core.jsx)(Col, (0, _extends2.default)({}, props, {
      ref: ref,
      container: Container
    }));
  });
};

var ColWithDocs = (0, _stencilReactDesc.describe)(ColStyled).description('Flex defaulting to column direction, for implementing vertical layouts.');
ColWithDocs.propTypes = (0, _objectSpread2.default)({}, (0, _utils.omit)(_Flex.default.describedPropTypes, ['flexDirection']));
ColWithDocs.displayName = 'Col';
var _default = ColWithDocs;
exports.default = _default;